<template>
  <van-tabbar v-model="active" :border="false" :z-index="101">
    <van-tabbar-item :to="{ path: '/home' }">
      <i slot="icon" class="home"></i>{{ $t("common.home") }}
    </van-tabbar-item>
    <van-tabbar-item   :to="{ path: '/wallet' }">
      <i slot="icon" class="wallet"></i>{{ $t("common.wallet") }}
    </van-tabbar-item>
    <van-tabbar-item :to="{ path: '/life' }">
      <i slot="icon" class="life"></i>{{ $t("common.life") }}
    </van-tabbar-item>
    <van-tabbar-item :to="{ path: '/personal' }">
      <i slot="icon" class="my"></i>{{ $t("common.my") }}
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
const TOPATH = ["home", "wallet", "life", "personal"];
export default {
  components: {},
  data() {
    return {
      active: -1
    };
  },
  created() {
    var path = this.$route.path.substring(1);
    this._showNavChane(path);
  },
  // mounted() {},
  computed: {},
  methods: {
    _showNavChane(path) {
      this.active = TOPATH.indexOf(path);
    }
  },
  watch: {
    $route(to) {
      // 路由方式变化
      var path = to.path.substring(1);
      this._showNavChane(path);
    }
  }
};
</script>

<style lang="less" scoped>
.van-tabbar {
  height: 50px;
  background: #fff;
  box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.1);
  &.van-hairline--top-bottom::after {
    content: normal;
  }
  .van-tabbar-item {
    color: #4a4a4a;
    /deep/.van-tabbar-item__icon {
      width: 100%;
    }
    i {
      width: 24px;
      height: 24px;
      display: block;
      margin: 0 auto;
      background-repeat: no-repeat;
      background-position: bottom;
      background-size: 100%;
      &.home {
        background-image: url("~@/assets/images/tabbar/icon_home_nor@2x.png");
      }
      &.wallet {
        background-image: url("~@/assets/images/tabbar/icon_wallet_nor@2x.png");
      }
      &.life {
        background-image: url("~@/assets/images/tabbar/icon_operation_nor@2x.png");
      }
      &.my {
        background-image: url("~@/assets/images/tabbar/icon_my_nor@2x.png");
      }
    }
    &.van-tabbar-item--active {
      color: #2042ab;
      i {
        &.home {
          background-image: url("~@/assets/images/tabbar/icon_home_sel@2x.png");
        }
        &.wallet {
          background-image: url("~@/assets/images/tabbar/icon_wallet_sel@2x.png");
        }
        &.life {
          background-image: url("~@/assets/images/tabbar/icon_operation_sel@2x.png");
        }
        &.my {
          background-image: url("~@/assets/images/tabbar/icon_my_sel@2x.png");
        }
      }
    }
  }
}
</style>
